import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path fill="#D8FFFF" d="M80.73 20.22a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#00D8D8"
      d="m99.38 15.22 3.94-3.94c.59-.59.59-1.54 0-2.12a1.49 1.49 0 0 0-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0 1.49 1.49 0 0 0 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12z"
    />
    <path
      fill="#D8FFFF"
      d="M44.44 101.82a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00D8D8"
      d="M17.38 77.57h-5.57V72c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57H3.25c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5zM23.23 105.82c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M93.64 35.81c0-2.62-2.13-4.75-4.75-4.75H27.11c-2.62 0-4.75 2.13-4.75 4.75v9.51h71.29v-9.51z"
    />
    <path
      fill="#0597A3"
      d="M22.36 45.31v33.27c0 2.62 2.13 4.75 4.75 4.75h61.78c2.62 0 4.75-2.13 4.75-4.75V45.31z"
    />
    <path
      fill="#001A43"
      d="M60.07 61.82H33.93c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h26.14c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25M50.56 71.33H33.93c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h16.63c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25M94.79 72.8H71.84l-2.14-7.42h-6.95c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h4.7l5.02 17.37a1.494 1.494 0 0 0 1.86 1.02c.66-.19 1.08-.79 1.08-1.44h16.52c.62 0 1.16-.41 1.34-1l2.88-9.75a1.4 1.4 0 0 0-1.34-1.79z"
    />
    <path
      fill="#00D8D8"
      d="M91.69 93.32a4.44 4.44 0 1 0 0-8.88 4.44 4.44 0 0 0 0 8.88M74.92 93.32a4.44 4.44 0 1 0 0-8.88 4.44 4.44 0 0 0 0 8.88"
    />
  </svg>
);
const SvgEnrichedIconOnlineShoppingBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconOnlineShoppingBrand);
export default Memo;
